import { useEffect, useRef } from 'react';

// Types
import { AccessibleAlertProps } from './AccessibleAlert.types';

const AccessibleAlert = ({ children, shouldFocus = false }: AccessibleAlertProps) => {
  const errorRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (shouldFocus && errorRef.current) {
      errorRef.current.focus();
    }
  }, [shouldFocus]);

  return (
    <div ref={errorRef} aria-atomic="true" aria-live="assertive">
      {children}
    </div>
  );
};

export default AccessibleAlert;
